import React, { useMemo } from 'react';

import Toggle from 'components/partials/toggle/toggle';
import TableComponent from 'components/partials/table-component/table-component';

import { getOverviewTableSettings } from './overview-table-settings';

import type { OverviewRow } from '../results-step.types';

interface OverviewTabProps {
  rows: OverviewRow[];
  showModeledActualYear: boolean;
  onShowModeledActualYearChange: (value: boolean) => void;
}

const OverviewTab = ({
  rows,
  showModeledActualYear,
  onShowModeledActualYearChange,
}: OverviewTabProps): React.JSX.Element => {
  const columns = useMemo(
    () => getOverviewTableSettings({ showModeledActualYear }),
    [showModeledActualYear]
  );

  return (
    <div className="flex flex-col gap-3" data-testid="results-overview-tab">
      <h3 className="text-lg font-bold text-gray-700">
        Modeled aid applicants/comparison
      </h3>

      <div className="flex flex-col gap-2 overflow-hidden">
        <Toggle
          isToggleOn={showModeledActualYear}
          onToggleChange={onShowModeledActualYearChange}
          toggleText="Modeled current year results"
          labelPosition="right"
          size="sm"
          data-testid="results-modeled-actual-toggle"
        />

        <TableComponent
          columns={columns}
          data={rows}
          isLoading={false}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default OverviewTab;
